
export const GET_SUPERVISORS = 'GET_SUPERVISORS';
export const EDIT_SUPERVISOR = 'EDIT_SUPERVISOR';
export const NEW_SUPERVISOR = 'NEW_SUPERVISOR';
export const DELETE_SUPERVISOR = 'DELETE_SUPERVISOR';

export function getSupervisors(supervisors, error=null) {
    return {
        type: GET_SUPERVISORS,
        supervisors,
        error
    }
}

// export function handleGetSupervisors(id) {
//     return async (dispatch) => {
//         // dispatch(showLoading())
//         try {
//             const result = await getUniAdmins(id);
//             if(result){
//                 const supervisors = result.data.data;
//                 // dispatch(hideLoading())
//                 return dispatch(getSupervisors(supervisors));
//             }  else {
//                 // dispatch(hideLoading())
//                 return dispatch(getSupervisors(null, "Unknown error"));
//             }
//         } catch (error) {
//             // dispatch(hideLoading())
//             return dispatch(getSupervisors(null, error));
//         }
//     }
// }

export function editSupervisor (supervisor, error=null) {
    return {
        type: EDIT_SUPERVISOR,
        supervisor,
        error
    }
}

// export function handleEditSupervisor(uniId, adminId, data) {
//     return async (dispatch) => {
//         // dispatch(showLoading())
//         try {
//             const result = await editUniAdmin(uniId, adminId, data);
//             if(result){
//                 const supervisor = result.data.data;
//                 // dispatch(hideLoading())
//                 return dispatch(editSupervisor(supervisor));
//             }  else {
//                 // dispatch(hideLoading())
//                 return dispatch(editSupervisor(null, "Unknown error"));
//             }
//         } catch (error) {
//             // dispatch(hideLoading())
//             return dispatch(editSupervisor(null, error));
//         }
//     }
// }

export function addSupervisor (supervisor, error=null) {
    return {
        type: NEW_SUPERVISOR,
        supervisor,
        error
    }
}

// export function handleAddSupervisor(uniId, data) {
//     return async (dispatch) => {
//         // dispatch(showLoading())
//         try {
//             data.type = 1;
//             const result = await addUniAdmin(uniId, data);
//             if(result){
//                 const supervisor = result.data.data;
//                 // dispatch(hideLoading())
//                 return dispatch(addSupervisor(supervisor));
//             }  else {
//                 // dispatch(hideLoading())
//                 return dispatch(addSupervisor(null, "Unknown error"));
//             }
//         } catch (error) {
//             // dispatch(hideLoading())
//             return dispatch(addSupervisor(null, error));
//         }
//     }
// }

// Delete Supervisor
export function deleteSupervisor (id, error=null) {
    return {
        type: DELETE_SUPERVISOR,
        id,
        error
    }
}

// export function handleDeleteSupervisor(id) {
//     return async (dispatch) => {
//         // dispatch(showLoading())
//         try {
//             const result = await removeUniAdmin(id);
//             if(result){
//                 console.log(result)
//                 return dispatch(deleteSupervisor(id));
//             }  else {
//                 // dispatch(hideLoading())
//                 return dispatch(deleteSupervisor(null, "Unknown error"));
//             }
//         } catch (error) {
//             // dispatch(hideLoading())
//             return dispatch(deleteSupervisor(null, error));
//         }
//     }
// }